import { z } from 'zod';
import { ChargeablePreauthorization } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { ProcessPaymentFormField } from '../ProcessPaymentFormSchema';
import { gatewayPaymentForSelectedCardSchema } from '../GatewayPaymentForm/schema';

export const createUpdatePreauthorizationFormSchema = (
    preauthAmount: ChargeablePreauthorization['amount'] | undefined
) =>
    gatewayPaymentForSelectedCardSchema.extend({
        [ProcessPaymentFormField.Amount]: z
            .number()
            .min(preauthAmount?.value ?? 0, TextKey.UpdatePreauthorizationDialogFormAmountError),
    });

export type UpdatePreauthorizationFormValues = z.infer<ReturnType<typeof createUpdatePreauthorizationFormSchema>>;
